import { RoleData } from "@/common/types/roles"
import { dateTimeTransformer } from "@/common/utils/dateTransformer"
import { ArrowBigRight } from "lucide-react"
import { Link } from "react-router-dom"

export class RolesTransformer {
  static tableTransformer() {
    return (roles: RoleData[]) => {
      return roles.map((role) => {
        return {
          ...role,
          updatedAt: role.updated_at ? dateTimeTransformer(new Date(role.updated_at)) : '',
          actions: <Link to={`/tcard-roles/${role.id}`}><ArrowBigRight /></Link>
        }
      })
    }
  }
}
